<div class="container" aria-label="Main Content">

    <div class="row" id="main-content">
        <h1 class="col-sm-12 text-center" tabindex="0">{{'COMMON.SESSION_TIMEOUT' | translate}}</h1>
    </div>
    <br />
    <div class="row">
        <h2 class="col-sm-12 text-center" tabindex="0">{{'COMMON.RESTART_APPLICATION' | translate}}</h2>
    </div>
    <br />
    <div class="row">
        <button class="btn btn-primary restart-btn" (click)="restart()"
            tabindex="0">{{'COMMON.RESTART' | translate}}</button>
    </div>
    <br>
    
</div>